export default __webpack_public_path__ + "static/media/laval4.1129aecd.jpg";